import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
import MedicalExpensesBenefit from '../MedicalExpensesBenefit/index';
import TripInterruptionBenefit from '../TripInterruptionBenefit/index';
import TripDelayBenefit from '../TripDelayBenefit/index';
import BaggageBenefit from '../BaggageBenefit/index';
import AccidentalDeathAndDismemberment from '../AccidentalDeathAndDismemberment/index';
import RepatriationExpenseBenefit from '../RepatriationExpenseBenefit/index';
import InitDeclaration from '../InitDeclaration/index';
import FraudNotice from '../FraudNotice/index';
import AuthorizationCrum from '../AuthorizationCrum/index';
import SureGoAllBenefits from '../SureGoAllBenefits/index';
import DuesProtectPermissions from '../DuesProtectPermissions/index';
import DuesProtectPrivacyStatements from '../DuesProtectPrivacyStatements/index';
import DuesProtectHipaaNotice from '../DuesProtectHipaaNotice/index';
import P from '../../../../../components/P';
import OptionsContainer from '../../../components/OptionsContainer';
import { appConfig } from './../../../../../configureApp';
import Textbox from '../../../components/Textbox';
import FlexBox from '../../../../../components/FlexBox';

import {
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  listCodeForAuthorizationLookup,
  listCodeForDuesProtect,
  stepTravelDelayLookup,
} from '../../../dataMapper/claimCodeMapper';
export default function SubmitClaim(props) {
  const { submitted, signature, handleChange, emailAddress, handleDownload, showElectronicConsentDocument, electronicConsentDocument, errorEmails, FNOLDeclarationClaimsAdminCompanyName, TPAName, carrier, insuredsList, isClaimGroupAllowed } = props;
  const { selectedBenefits, selectedClaimFor  } = props.stepWhatHappenedData;
  const selectedClaimForList = !!selectedClaimFor && typeof selectedClaimFor.toJS === 'function'
    ? selectedClaimFor.toJS()
    : selectedClaimFor || [];
  const isMultipleClaimFor = insuredsList.length > 1 && isClaimGroupAllowed;
  const { areYouClaimingForAccidentalDeathAndDismemberment, areYouClaimingForRepatriationExpenses } = props.stepOtherData;
  const { travelInterruption } = props.stepTripCancellationAndTripInterruptionData;
  const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || []);
  const isStepOtherSelected = (list.filter((d) => ((stepOtherExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStepTripCancellationAndTripInterruptionSelected = (list.filter((d) => ((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStepBaggageAndPersonalItemsSelected = (list.filter((d) => ((stepBaggageAndPersonalItemsExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStepMedicalExpensesSelected = (list.filter((d) => ((stepMedicalExpensesExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isTravelDelay = (list.filter((d) => ((stepTravelDelayLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isTripInterruption = isStepTripCancellationAndTripInterruptionSelected && travelInterruption === 'true';
  const isVisibleAuthorizationCrum = (list.filter((d) => ((listCodeForAuthorizationLookup).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isVisibleDuesProtect = (list.filter((d) => ((listCodeForDuesProtect).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isReadOnly = submitted;
  let isChecked = null;
  if (electronicConsentDocument === true || electronicConsentDocument === 'true') {
    isChecked = 'true';
  }
  if (electronicConsentDocument === false || electronicConsentDocument === 'false') {
    isChecked = 'false';
  }
  const showFraudNotice = appConfig.showFraudNotice;
  return (
    <div>
      {!isVisibleDuesProtect &&
      <Section>
        <ControlContainer>
          <P>
            <FormattedMessage {...messages.youAreAboutToSubmitYourClaimAnd} {...messages.youAreAboutToSubmitYourClaimAnd.id} />
          </P>
          {/* {isVisibleAuthorizationCrum === true && <AuthorizationCrum />}
          {isStepMedicalExpensesSelected === true && <MedicalExpensesBenefit declarationClaimsAdminCompanyName={FNOLDeclarationClaimsAdminCompanyName} TPAName={TPAName} carrier={carrier} />}
          {isTripInterruption === true && <TripInterruptionBenefit />}
          {isTravelDelay === true && <TripDelayBenefit declarationClaimsAdminCompanyName={FNOLDeclarationClaimsAdminCompanyName} />}
          {isStepBaggageAndPersonalItemsSelected === true && <BaggageBenefit declarationClaimsAdminCompanyName={FNOLDeclarationClaimsAdminCompanyName} />}
          {isStepOtherSelected === true && areYouClaimingForAccidentalDeathAndDismemberment === 'true' && <AccidentalDeathAndDismemberment />}
          {isStepOtherSelected === true && areYouClaimingForRepatriationExpenses === 'true' && <RepatriationExpenseBenefit />} */}
          {<SureGoAllBenefits TPAName={TPAName} carrier={carrier} />}
          {showFraudNotice === true && <InitDeclaration />}
          {showFraudNotice === false && <FraudNotice />}
          {showElectronicConsentDocument === true &&
            <div>
              <div className={'row'}>
                <div className={'form-group col-md-8 col-sm-12'}>
                  <span>
                    <a href="https://www.mysurego.com/terms-and-conditions/" target="_blank" style={{ color: 'blue' }}><FormattedMessage {...messages.OnlineConsentDoc} id={messages.OnlineConsentDoc.id} /></a>
                  </span>
                </div>   
                <div className={'form-group col-md-12'}>
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="true"
                        checked={isChecked === 'true'}
                        onChange={handleChange('form.electronicConsentDocument')}
                      />
                      <FormattedMessage {...messages.yes} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="false"
                        checked={isChecked === 'false'}
                        onChange={handleChange('form.electronicConsentDocument')}
                      />
                      <FormattedMessage {...messages.no} />
                    </OptionsContainer>
                    { isMultipleClaimFor &&
                    <OptionsContainer>
                      <FormattedMessage {...messages.agreeSureGoPolicyv2} />
                    </OptionsContainer>
                    }
                    { !isMultipleClaimFor &&
                    <OptionsContainer>
                      <FormattedMessage {...messages.agreeSureGoPolicy} id={messages.agreeSureGoPolicy.id} />
                    </OptionsContainer>
                    }
                  </FlexBox>
                </div>
                <div className={'form-group col-md-8 col-sm-12'}>
                  <span>
                    <FormattedMessage {...messages.iHaveReadAndAgree} id={messages.iHaveReadAndAgree.id} />
                  </span>
                </div>
                {(isChecked === 'true' && !isMultipleClaimFor) &&
                  <div className={'col-sm-8 form-group'}>
                    <span>
                      <FormattedMessage {...messages.theEmailAddressToBeUsed} id={messages.theEmailAddressToBeUsed.id} />
                    </span>
                    <Textbox
                      disabled={isReadOnly}
                      name="emailAddress"
                      type="email"
                      onChange={handleChange('form.emailAddress')}
                      value={emailAddress}
                    />
                    {errorEmails && <p style={{ color: 'red', fontSize: '13px' }}>{errorEmails}</p>}
                  </div>
                }
                <div className={'form-group col-md-8 col-sm-12'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="signature"
                      checked={signature === true}
                      onChange={handleChange('form.signature')}
                    />
                    <span>
                      <FormattedMessage {...messages.agree} id={messages.agree.id} />
                    </span>
                  </OptionsContainer>
                </div>
              </div>
            </div>
          }
          {showElectronicConsentDocument !== true &&
          <div className={'row'}>
            <div className={'form-group col-md-6 col-sm-9'}>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="signature"
                  checked={signature === true}
                  onChange={handleChange('form.signature')}
                />
                <span>
                  <FormattedMessage {...messages.agree} id={messages.agree.id} />
                </span>
              </OptionsContainer>
            </div>
          </div>
          }
          <P style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
            <FormattedMessage {...messages.clickSubmitClaim} id={messages.clickSubmitClaim.id} />
          </P>
          <Section>
            <ControlContainer>
              <P style={{ fontWeight: 'bold' }}>
                <FormattedMessage {...messages.privacyStatement} id={messages.privacyStatement.id} />
              </P>
              <P style={{ fontStyle: 'italic' }}>
                <FormattedMessage {...messages.privacyStatementMessage1} id={messages.privacyStatementMessage1.id} /> <a href={appConfig.privacyStatementUrl} target="_blank"><FormattedMessage {...messages.here} id={messages.here.id} /></a>. <FormattedMessage {...messages.privacyStatementMessage2} id={messages.privacyStatementMessage2.id} />
              </P>
            </ControlContainer>
          </Section>
        </ControlContainer>
      </Section>
      }
      {isVisibleDuesProtect &&
      <Section>
        <ControlContainer>
          <P>
            <FormattedMessage {...messages.youAreAboutToSubmitYourClaimAnd} id={messages.youAreAboutToSubmitYourClaimAnd.id} />
          </P>
          {<DuesProtectPermissions />}
          <div className={'row'}>
            <div className={'form-group col-md-9 col-sm-9'}>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="signature"
                  checked={signature === true}
                  onChange={handleChange('form.signature')}
                />
                <span>
                  <FormattedMessage {...messages.agreeDuesProtect} id={messages.agreeDuesProtect.id} />
                </span>
              </OptionsContainer>
            </div>
          </div>
          {<DuesProtectPrivacyStatements />}
          {<DuesProtectHipaaNotice />}
        </ControlContainer>
      </Section>
      }
    </div>
  );
}

SubmitClaim.propTypes = {
  submitted: PropTypes.bool,
  signature: PropTypes.bool,
  emailAddress: PropTypes.any,
  handleDownload: PropTypes.func,
  handleChange: PropTypes.func,
  stepWhatHappenedData: PropTypes.any,
  stepTripCancellationAndTripInterruptionData: PropTypes.any,
  stepOtherData: PropTypes.any,
  showElectronicConsentDocument: PropTypes.bool,
  electronicConsentDocument: PropTypes.bool,
  errorEmails: PropTypes.any,
  FNOLDeclarationClaimsAdminCompanyName: PropTypes.any,
  TPAName: PropTypes.any,
  carrier: PropTypes.any,
  insuredsList: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/index.js